import React,{useState,useEffect } from 'react'
import { ToastContainer } from "react-toastify";
import useAxios from 'hooks/useAxios';
import ErrorBoundary from "components/ErrorBoundary";
import FormularyTable from './components/FormularyTable';
import { isEmpty } from 'lodash';
import { onExport, getUpdatedFilter } from 'utils/helper';

import { Card, CardBody, Container } from 'reactstrap';
import SearchFormulary from './components/SearchFormulary';

const initialFilterBySearch = {
  coveredEntityName: '',

};

const tenantID = '';

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};

let selectedCoveredEntity = {};

const FormularySearch = () => {
  const API = useAxios();
    const [state, updateState] = useState({
        data: [],
        coveredEntity: [],
        loading: false,
        selectedEntity: '',
        coveredId: '',
        records: 0,
        reset: false,
    });
    
    const [ceId, setCEId] = useState('');


  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const [columnFilters , setColumnFilters] = useState(null) ;
  const [collapseSider, setcollapseSider] = useState(false);

  useEffect(() => {
    initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: '',
        order: '',
        filters: [],
    };
    setColumnFilters(null);
   
    setState({ data: [], records: 0 });
    selectedCoveredEntity = {};
}, []);


  const handlePageChange = ({currentPage: page}) => {
    const { pageSize } = pageFilter;
    console.log({page})
    setState({loading: true})
    setTimeout(() => {
      let splicedData = copyData.slice((page === 1 ? 0 : page * pageSize) , pageSize * (page + 1));
      setPageFilter(pre => ({...pre, page: page}));
      setState({loading: false, formularyData: splicedData });
    },600);
  };

  const onSearch = async (filters) => {
    const { coveredEntityName } = filters;
    if (coveredEntityName) {
        initialFilters.filters = getUpdatedFilter(
            'CEID',
            parseInt(coveredEntityName),
            initialFilters
        );
        initialFilters.currentPage = 1;
        fetchFormularyData(initialFilters);
    }
};

const onReset = () => {
    initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: '',
        order: '',
        filters: [],
    };
    setState({ data: [], reset: !state.reset, records: 0 });
    selectedCoveredEntity = {};
}; 

const fetchFormularyData = async (pageDetails = {}, hasColumnFilter) => {
  setState({ loading: true });
  let filter = { ...pageDetails };
  if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      //initialFilters.filters = [...filter.filters];
  } else {
    initialFilters = { ...initialFilters, ...filter };
  }
  let ceidFilter = initialFilters?.filters?.find(filter => filter.filterName === "CEID");

  let id = ceidFilter?.filterValue;
  setColumnFilters(filter);
  try {
      const { data } = await API.post(
          `GWConfig/Formulary/All/${id}`,
          filter,{
            hasDefaultURL: true,
          }
      );
      if (data) {
          setState({
              data: data.items,
              records: data.totalRecords,
              loading: false,
          });
      } else {
          setState({
              data: [],
              records: 0,
              loading: false,
          });
      }
  } catch (error) {
      setState({ loading: false, data: [], records: 0 });
  }
}; 

  const handleExport = async () => {
 
 
    let filterObj = columnFilters ? columnFilters : initialFilters;
 
 
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    var payload = {};
    payload.gridCode = "formulary";
    payload.fileTypeCode = "csv";
    payload.tenantID = tenantID;
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


const onPageChange = (filter, hasFilter) => {
  if (hasFilter) {
    fetchFormularyData(filter, true);
  } else {
    fetchFormularyData(filter);
  }
};

const handleSearchColumnFilters = async (columnFilters) => {
  await fetchFormularyData({ ...initialFilters, ...columnFilters }, true);
};
const handleUpdateEntity = (entity) => {
  selectedCoveredEntity = entity;
};

const refetch = (hasReset) => {
  if (hasReset) {
      initialFilters = {
          ...initialFilters,
          currentPage: 1,
      };
  }
  fetchFormularyData(initialFilters);
};

const toggleSider = () => {
  setcollapseSider(!collapseSider);
  if (!collapseSider) {
    setCollIcon(faAngleDown);
  } else {
    setCollIcon(faAngleUp);
  }
};


  return (
    
    <div>
       <Container fluid className="width_info">
      <div className={collapseSider ? "mb-0" : "mb-3"}>
        <Card className="border-0 shadow-top">
          <CardBody  hidden={collapseSider} className="">
            <ErrorBoundary>
              <SearchFormulary               
              initialValue={initialFilterBySearch}
              onSearch={onSearch} 
              onReset={onReset} 
              handleUpdateEntity={handleUpdateEntity} />
              </ErrorBoundary>
          </CardBody>
          </Card>
          </div>
                   <Card className="border-0 shadow-top">
          <CardBody>
            <ErrorBoundary>
              <FormularyTable
                data={state.data}
                loading={state.loading}
                onExport={handleExport}
                filters={initialFilters}
                totalSize={state.records}
                onPageChange={onPageChange}
                coveredEntityID={selectedCoveredEntity.coveredEntityID}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={state.reset}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
export default FormularySearch